import {createSlice} from '@reduxjs/toolkit'

export const campaignViewSlice = createSlice({
  name: 'campaignView',
  initialState: {
    defaultValue: 'defaultView'
  },
  reducers: {
    setCampaignView: (state, action) => {
      state.defaultValue = action.payload
    }
  }
})

export const {setCampaignView} = campaignViewSlice.actions

export default campaignViewSlice.reducer
